var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSquadPlayIcon = function SvgSquadPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SquadPlayIcon_svg__Group_2265",
    viewBox: "0 0 20.014 12.735"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".SquadPlayIcon_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2258",
    transform: "translate(17.63 2.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SquadPlayIcon_svg__Path_544",
    d: "M452.8 228.111H451v8.209h1.8a.586.586 0 00.586-.586V228.7a.586.586 0 00-.586-.589z",
    className: "SquadPlayIcon_svg__cls-1",
    transform: "translate(-451 -228.111)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2260",
    transform: "translate(0 2.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SquadPlayIcon_svg__Path_545",
    d: "M.586 228.111A.586.586 0 000 228.7v7.036a.586.586 0 00.586.586h1.8v-8.209z",
    className: "SquadPlayIcon_svg__cls-1",
    transform: "translate(0 -228.111)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2262",
    transform: "translate(6.725 2.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SquadPlayIcon_svg__Path_546",
    d: "M174.884 243.111a1.166 1.166 0 00-1.049.648l-1.785 3.571a2.337 2.337 0 003.034-1.1l.386-.772h1.135a1.181 1.181 0 01.829.344l4.347 4.347v-7.036z",
    className: "SquadPlayIcon_svg__cls-1",
    transform: "translate(-172.05 -243.111)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2264",
    transform: "translate(3.557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SquadPlayIcon_svg__Group_2263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SquadPlayIcon_svg__Path_547",
    d: "M98.723 174.56h-.41l-.034.068a3.572 3.572 0 01-2.868 1.991 4.247 4.247 0 01-2.284-.526.59.59 0 01-.286-.8l2.063-4.127a2.346 2.346 0 012.1-1.3h2.53a2.835 2.835 0 00.266-1.166.586.586 0 00-.586-.586h-4.557a1.759 1.759 0 00-1.574.973l-.524 1.049a.586.586 0 01-.525.324H91v8.209h2.689l1.661 1.661a1.739 1.739 0 001.773.433l5.007-1.574a1.7 1.7 0 00.757-.46z",
    className: "SquadPlayIcon_svg__cls-1",
    transform: "translate(-91 -168.11)"
  })))));
};
export default SvgSquadPlayIcon;